import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaChartBar,
  FaFileInvoiceDollar,
  FaUserFriends,
  FaSignOutAlt,
  FaBars,
  FaChevronLeft,
} from "react-icons/fa";

export default function Navbar() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [statsOpen, setStatsOpen] = useState(false); // ← desplegable de Estadísticas

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // Links “simples”
  const links = [
    { to: "/dashboard", label: "Ventas Fijo", icon: <FaChartBar /> },
    { to: "/ventasmovil", label: "Ventas Móvil", icon: <FaFileInvoiceDollar /> },
    { to: "/ejecutivos", label: "Ejecutivos", icon: <FaUserFriends /> },
    // OJO: quitamos el link directo a /estadisticas, ahora es un bloque desplegable
  ];

  return (
    <aside
      className={`min-h-screen bg-[#0096ad] text-white flex flex-col shadow-lg transition-all duration-300 ${
        collapsed ? "w-20" : "w-60"
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        {!collapsed && (
          <span className="font-bold text-[#64FFDA] text-lg">TeleVentas</span>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-white/70 hover:text-white transition"
          aria-label="Alternar menú"
        >
          {collapsed ? <FaBars /> : <FaChevronLeft />}
        </button>
      </div>

      {/* Navegación */}
      <nav className="flex-1 px-2 space-y-2">
        {/* Links planos */}
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg transition-all ${
                isActive
                  ? "bg-[#2e3d34] text-[#64FFDA]"
                  : "text-white/70 hover:bg-[#27382f] hover:text-white"
              }`
            }
          >
            <span className="text-lg">{link.icon}</span>
            {!collapsed && (
              <span className="text-sm font-medium whitespace-nowrap">
                {link.label}
              </span>
            )}
          </NavLink>
        ))}

        {/* Bloque desplegable: Estadísticas */}
        <div className="space-y-1">
          {/* Botón padre */}
          <button
            type="button"
            onClick={() => setStatsOpen((v) => !v)}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all
              ${statsOpen ? "bg-[#2e3d34] text-[#64FFDA]" : "text-white/70 hover:bg-[#27382f] hover:text-white"}
            `}
            aria-expanded={statsOpen}
            aria-controls="submenu-estadisticas"
            title="Estadísticas"
          >
            <span className="text-lg"><FaChartBar /></span>
            {!collapsed && (
              <>
                <span className="text-sm font-medium whitespace-nowrap flex-1">
                  Estadísticas
                </span>
                {/* Usamos FaChevronLeft rotado como caret */}
                <span
                  className={`transition-transform ${statsOpen ? "-rotate-90" : "rotate-90"}`}
                >
                  <FaChevronLeft />
                </span>
              </>
            )}
          </button>

          {/* Submenú */}
          <div
            id="submenu-estadisticas"
            className={`${statsOpen ? "block" : "hidden"}`}
          >
            {/* Opción: Masivo */}
            <NavLink
              to="/estadisticas/masivo"
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg transition-all
                 ${collapsed ? "justify-center px-0 py-2" : "px-3 py-2 ml-7"}
                 ${isActive ? "text-[#64FFDA]" : "text-white/70 hover:text-white"}`
              }
            >
              <span className="w-2 h-2 rounded-full bg-white/60" />
              {!collapsed && <span className="text-sm">Masivo</span>}
            </NavLink>

            {/* Opción: Pyme */}
            <NavLink
              to="/estadisticas/pyme"
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg transition-all
                 ${collapsed ? "justify-center px-0 py-2" : "px-3 py-2 ml-7"}
                 ${isActive ? "text-[#64FFDA]" : "text-white/70 hover:text-white"}`
              }
            >
              <span className="w-2 h-2 rounded-full bg-white/60" />
              {!collapsed && <span className="text-sm">Pyme</span>}
            </NavLink>

            {/* Opción: SSPP */}
            <NavLink
              to="/estadisticas/sspp"
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg transition-all
                 ${collapsed ? "justify-center px-0 py-2" : "px-3 py-2 ml-7"}
                 ${isActive ? "text-[#64FFDA]" : "text-white/70 hover:text-white"}`
              }
            >
              <span className="w-2 h-2 rounded-full bg-white/60" />
              {!collapsed && <span className="text-sm">SSPP</span>}
            </NavLink>
          </div>
        </div>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 text-white/70 hover:text-red-400 transition-all"
        >
          <FaSignOutAlt />
          {!collapsed && <span className="text-sm">Cerrar sesión</span>}
        </button>
      </div>
    </aside>
  );
}
